import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_pk\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_pk)\"><rect width=\"5\" height=\"20\" fill=\"#FFFFFF\"></rect><rect x=\"5\" width=\"15\" height=\"20\" fill=\"#01411C\"></rect><path d=\"M 12.5 10 A 3 3 0 1 1 12.5 10.01 Z\" fill=\"#FFFFFF\"></path><path d=\"M 13.2 10 A 2.5 2.5 0 1 1 13.2 10.01 Z\" fill=\"#01411C\"></path><path d=\"M 14.5 8.5 L 14.9 9.5 L 15.9 9.5 L 15.1 10.1 L 15.5 11.1 L 14.5 10.4 L 13.5 11.1 L 13.9 10.1 L 13.1 9.5 L 14.1 9.5 Z\" fill=\"#FFFFFF\"></path></g>", 2)
  ])))
}
export default { render: render }